import { multiMap } from '../map/map-multi.js';

export default {
  init() {
    multiMap();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js